module.exports = __webpack_public_path__ + "img/czechia.0ec5a2b8.svg";